import { selfAxios } from "@oppein/op-utils";

/**
 * 根据组织编码查询审批配置详情列表（含角色配置列表和审批人配置列表）
 */
export async function findAuditConfigDetailListByOrgNo(params) {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationEContractAuditController/findAuditConfigDetailListByOrgNo",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/quotaion/designQuotationEContractAuditController/findAuditConfigDetailListByOrgNo/post.js